module.exports = __webpack_public_path__ + "assets/img/c74907776e7b4ff98369699cd00fbff1.png";